
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[gameId]",
      function () {
        return require("private-next-pages/[gameId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[gameId]"])
      });
    }
  